const departmentList = [
  { id: 1, name: "機械創造工学分野" },
  { id: 2, name: "電気電子情報工学分野" },
  { id: 3, name: "情報・経営システム工学分野" },
  { id: 4, name: "物質生物工学分野" },
  { id: 5, name: "環境社会基盤工学分野" },
  { id: 6, name: "機械創造工学課程" },
  { id: 7, name: "電気電子情報工学課程" },
  { id: 8, name: "物質材料工学課程" },
  { id: 9, name: "環境社会基盤工学課程" },
  { id: 10, name: "生物機能工学課程" },
  { id: 11, name: "情報・経営システム工学課程" },
  { id: 12, name: "機械創造工学専攻" },
  { id: 13, name: "電気電子情報工学専攻" },
  { id: 14, name: "物質材料工学専攻" },
  { id: 15, name: "環境社会基盤工学専攻" },
  { id: 16, name: "生物機能工学専攻" },
  { id: 17, name: "情報・経営システム工学専攻" },
  { id: 18, name: "原子力システム安全工学専攻" },
  { id: 19, name: "システム安全専攻" },
  { id: 20, name: "技術科学イノベーション専攻" },
  { id: 21, name: "情報・制御工学専攻" },
  { id: 22, name: "材料工学専攻" },
  { id: 23, name: "エネルギー・環境工学専攻" },
  { id: 24, name: "生物統合工学専攻" },
  { id: 25, name: "その他" }
]

export default departmentList